import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from './translate.pipe';
import { TranslateMenuPipe } from './translate_menu.pipe';
import { GetClassPipe } from './get-class.pipe';
import { ExponentialPipe } from './exponential.pipe';


@NgModule({
    imports:      [ CommonModule],
    declarations: [ TranslatePipe,TranslateMenuPipe, GetClassPipe, ExponentialPipe],
    exports:      [ TranslatePipe,TranslateMenuPipe,GetClassPipe,ExponentialPipe],
    providers:      [ TranslatePipe,TranslateMenuPipe,ExponentialPipe],
  })
  export class TranslateModule { }